import { useState } from "react";
import axios from "axios";
import { toast } from "sonner";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function Newsletter() {
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (!email.includes("@")) {
      toast.error("Adresse email invalide");
      return;
    }
    setLoading(true);
    try {
      await axios.post(`${API}/newsletter`, { email });
      toast.success("Merci pour votre inscription.");
      setEmail("");
    } catch (err) {
      toast.error("Une erreur est survenue. Merci de réessayer.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <form
      data-testid="newsletter-form"
      onSubmit={submit}
      className="flex flex-col sm:flex-row gap-2"
    >
      <input
        type="email"
        required
        value={email}
        onChange={(e) => setEmail(e.target.value)}
        placeholder="votre@email.fr"
        data-testid="newsletter-input"
        className="flex-1 bg-white/5 border border-[#1A3454] text-white placeholder:text-[#7891B0] px-4 py-3 text-sm rounded-none focus:outline-none focus:border-[#C5A059]"
      />
      <button
        type="submit"
        disabled={loading}
        data-testid="newsletter-submit"
        className="bg-[#C5A059] text-[#0C2340] font-medium px-5 py-3 text-sm hover:bg-[#D4B374] transition-colors disabled:opacity-60"
      >
        {loading ? "…" : "S'inscrire"}
      </button>
    </form>
  );
}
